module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"gave_mileage_message":"<b>已发放 {mileage_amount}｜</b>","hidden_by_admin_message":"该评价未达到发布标准，暂不予显示。","hidden_by_system_message":"该评价未达到发布标准，暂不予显示。","hidden_by_before_confirmation_message":"内容正在审核中，审核通过后将予以显示。","review_edit_or_delete_info":"如需修改或删除评价，请联系商城客服。"}}')
  delete Component.options._Ctor
}
